<!--
 * @Author: vince
 * @Date: 2021-09-01 14:54:15
 * @LastEditors: vince
 * @LastEditTime: 2021-09-06 10:35:29
 * @Description:
-->
<template>
	<div ref="chart" class="chart"></div>
</template>
<script>
import * as echarts from "echarts";
import "echarts/theme/macarons";
export default {
	props: {
		option: {
			type: Object,
			require: true
		}
	},
	data() {
		return {
			myChart: null
		};
	},
	watch: {
		option() {
			this.myChart.setOption(this.option);
		}
	},
	mounted() {
		this.myChart = echarts.init(this.$refs.chart, "macarons", {
			width: "auto",
			height: "auto"
    });
    this.myChart.on('click', (e) => {
      console.log(e)
      this.$emit('click',e)
    })
		this.myChart.setOption(this.option);
		const resizeObserver = new ResizeObserver(entries => {
			this.myChart.resize();
		});
		resizeObserver.observe(this.$refs.chart.parentNode);
	}
};
</script>

<style>
.chart {
	width: 100%;
	height: 100%;
}
</style>



